import { InfiniteScroll } from 'components/infinite_scroll/InfiniteScroll';
import { styled } from 'styled-components';
import { tokens } from 'styles/tokens';

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.8rem;
    width: 100%;
    align-items: center;
    justify-content: space-between;
`;

export const Title = styled.h2`
    font-weight: 500;
    font-size: 2.4rem;
    line-height: 1.25;
    color: ${tokens.text.primary};
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.8rem;
`;

export const HeaderRightContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const ExternalLink = styled.a`
    color: ${tokens.text.link};
    font-size: 1.4rem;
    font-weight: 400;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 0.8rem;

    &:hover {
        text-decoration: underline;
    }

    svg {
        font-size: 1.2rem;
    }
`;

export const AssetsWithAlertsContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    flex: 1;
    min-height: 0;
`;

export const ScrollContainer = styled(InfiniteScroll)`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-right: 0.8rem;
`;

export const EmptyState = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 2.4rem;
    color: ${tokens.text.secondary};
    font-size: 1.4rem;
    text-align: center;
`;

export const LoadingState = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.6rem;
    color: ${tokens.text.secondary};
    font-size: 1.4rem;
`;
